// Tipos de documento de identidad - Colombia
export const TIPOS_IDENTIFICACIONES = [
  { value: "CC", text: "Cédula de Ciudadanía" },
  { value: "TI", text: "Tarjeta de identidad" },
  { value: "CE", text: "Cédula de Extranjería" },
  { value: "PS", text: "Pasaporte" },
  { value: "RC", text: "Registro civil" },
  { value: "NUIP", text: "Número único de identificación personal" },
  { value: "OT", text: "Otro" },
];

// Procedimiento (Colombia Salud)
export const TIPOS_PROCEDIMIENTO = [
  { value: "INCLUSION", text: "Inclusión" },
  { value: "MODIFICACION", text: "Modificación asegurados" },
  { value: "ACTUALIZACION", text: "Actualización de datos" },
];

export const TIPOS_SEXO = [
  { value: "M", text: "Masculino" },
  { value: "F", text: "Femenino" },
];

export const TIPOS_SINO = [
  { value: "S", text: "Sí" },
  { value: "N", text: "No" },
];

// Parentesco - Relación de personas a asegurar (PDF)
export const TIPOS_DEPENDIENTES = [
  { value: "A1", text: "Asegurado Principal" },
  { value: "CY", text: "Cónyuge" },
  { value: "HJ", text: "Hijo(a)" },
  { value: "MD", text: "Madre" },
  { value: "PD", text: "Padre" },
];

/** Filas Sí/No del PDF (CUESTIONARIO_MEDICO_0 … _22). */
export const CANTIDAD_FILAS_CUESTIONARIO_SINO = 23;

// Cuestionario médico — FormColombia-SaludV2.pdf
/* eslint-disable max-len */
export const PREGUNTAS_CUESTIONARIO_MEDICO = [
  { code: 1, pdfRow: 0, type: "sino", label: "¿Enfermedades del oído, nariz, garganta o defectos de la vista?" },
  {
    code: 2,
    pdfRow: 1,
    type: "sino",
    label:
      "¿Desmayos o mareos, convulsiones, dolores de cabeza severos, trastornos mentales o nerviosos, " +
      "defecto al hablar, parálisis, embolia?",
  },
  {
    code: 3,
    pdfRow: 2,
    type: "sino",
    label:
      "¿Asfixia, ronquera o catarro persistente, expectora sangre, tos crónica, trastornos respiratorios " +
      "crónicos, bronquitis, asma, pleuresía, enfisema, tuberculosis?",
  },
  {
    code: 4,
    pdfRow: 3,
    type: "sino",
    label:
      "¿Dolores de pecho, palpitaciones, presión arterial alta o baja, soplo en el corazón, o cualquier " +
      "otro trastorno del corazón o vasos arteriales, venas varicosas?",
  },
  {
    code: 5,
    pdfRow: 4,
    type: "sino",
    label:
      "¿Ictericia, hemorragia intestinal, úlcera, apendicitis, colitis, diverticulitis, hemorroides, " +
      "indigestión recurrente, o cualquier otro trastorno del estómago, intestino, hígado o vesícula?",
  },
  {
    code: 6,
    pdfRow: 5,
    type: "sino",
    label:
      "¿Azúcar, albúmina, sangre o pus en la orina, enfermedades venéreas, nefritis, cálculos o " +
      "cualquier otro trastorno del riñón, vejiga, próstata, páncreas, hernias, trastorno urinario, " +
      "del recto y órganos reproductivos?",
  },
  { code: 7, pdfRow: 6, type: "sino", label: "¿Diabetes, tiroides u otro trastorno endocrinológico?" },
  { code: 8, pdfRow: 7, type: "sino", label: "¿Neuritis, ciática, reumatismo, artritis, gota, fiebre reumática?" },
  {
    code: 9,
    pdfRow: 8,
    type: "sino",
    label:
      "¿Deformación, cojera, amputación o menoscabo físico, trastornos de los músculos o huesos, " +
      "lesiones óseas de la cabeza, espina dorsal?",
  },
  { code: 10, pdfRow: 9, type: "sino", label: "¿Alergias, anemia o cualquier otro trastorno de la sangre?" },
  { code: 11, pdfRow: 10, type: "sino", label: "¿Trastornos del sistema inmunológico?" },
  {
    code: 12,
    pdfRow: 11,
    type: "sino",
    label:
      "¿Tiene usted actualmente cáncer o antecedentes oncológicos recientes, ya sea porque se encuentra " +
      "en tratamiento o porque la finalización de su tratamiento ocurrió hace menos de cuatro (4) años " +
      '(o menos de dos (2) años si fue diagnosticado(a) siendo menor de edad)?. Si la respuesta es "No", ' +
      "queda amparado por el derecho al olvido oncológico de acuerdo con la ley 2475 del 2025 y no deberá " +
      "declarar ni informar datos adicionales sobre su historial oncológico.",
  },
  {
    code: 13,
    pdfRow: 12,
    type: "sino",
    label: "¿Algún trastorno mental o físico que no haya sido mencionado anteriormente?",
  },
  { code: 14, pdfRow: 13, type: "sino", label: "¿Trastornos de la piel o quistes?" },
  { code: 15, pdfRow: 14, type: "sino", label: "¿Padece alguna enfermedad o defecto congénito?" },
  {
    code: 16,
    pdfRow: 15,
    type: "sino",
    label:
      "¿Ha consultado algún médico o le han recomendado hacerse algún examen para diagnóstico, " +
      "hospitalización o cirugía que no haya sido realizado?",
  },
  {
    code: 17,
    pdfRow: 16,
    type: "sino",
    label: "¿Le han efectuado un electrocardiograma, rayos X o cualquier otro examen para diagnóstico?",
  },
  {
    code: 18,
    pdfRow: 17,
    type: "sino",
    label: "¿Ha estado alguna vez internado en un hospital, clínica, por razones de diagnóstico o tratamiento?",
  },
  {
    code: 19,
    pdfRow: 18,
    type: "sino",
    label:
      "¿En algún momento ha solicitado o recibido beneficios o pagos de una pensión, debido a un " +
      "accidente, enfermedad o incapacidad?",
  },
  {
    code: 20,
    pdfRow: 19,
    type: "sino",
    label:
      "¿Se encuentra en estos momentos bajo la observación de un médico legalmente autorizado, " +
      "tomando algún medicamento o recibiendo algún tratamiento por algún motivo?",
  },
  {
    code: 21,
    pdfRow: 20,
    type: "sino",
    label:
      "¿Está usando o ha usado alguna vez barbitúricos, anfetaminas, droga que produce " +
      "alucinamientos, narcóticos o cualquier otra droga?",
  },
  {
    code: 22,
    pdfRow: 21,
    type: "sino",
    label: "¿Ha recibido o necesita asesoramiento, consejo o tratamiento en relación al uso de drogas o alcohol?",
  },
  {
    code: 23,
    pdfRow: 22,
    type: "sino",
    label:
      "Para mujeres únicamente: ¿Trastornos femeninos, órganos reproductivos, menstruación, " +
      "embarazo o problemas de los senos?",
  },
  {
    code: 24,
    type: "fecha",
    label:
      "Para mujeres únicamente: ¿Se encuentra actualmente embarazada? (o su cónyuge) si se encuentra, " +
      "favor de indicar la fecha en que se espera el alumbramiento.",
  },
  {
    code: 25,
    type: "p24",
    label: "Para mujeres únicamente, detalle (embarazos, partos, abortos, cesáreas)",
  },
];
/* eslint-enable max-len */
